/** Why "Start review" is still disabled — shown next to the button. */

export type DraftSource = "upload" | "document";

/** What still blocks "Start review", in the order the form asks for it. */
export function missingForReview(input: {
  name: string;
  source: DraftSource;
  hasUpload: boolean;
  draftCollectionId: string | null;
  draftDocumentId: string | null;
  referenceCount: number;
}): string[] {
  const missing: string[] = [];
  if (!input.name.trim()) missing.push("add a name");
  if (input.source === "upload") {
    if (!input.hasUpload) missing.push("upload the draft file");
  } else if (!input.draftCollectionId) {
    missing.push("choose the collection holding the draft");
  } else if (!input.draftDocumentId) {
    missing.push("choose the draft document");
  }
  if (input.referenceCount === 0) missing.push("choose at least one reference collection");
  return missing;
}
